<template>
  <div class="success">
    <Poptip placement="bottom" content="content">
      <a class="success-num" v-if="row.orderNum > 0">{{ row.orderNum }}</a>
      <div slot="content">
        <div class="policy-list-box">
          <span class="title">共 {{ row.orderNoList&&row.orderNoList.length }} 份订单</span>
          <div class="list" v-for="(item, index) in row.orderNoList" :key="index">
            <span class="policy-label">订单号：</span>
            <a class="policy-number" @click="$refs.orderDetail.open({orderNo:item,orgName:row.organizationName,groupName:row.groupName,salesmanName:row.agentName})">{{ item }}</a>
          </div>
        </div>
      </div>
    </Poptip>
    <span v-if="row.orderNum == 0">{{ row.orderNum }}</span>

    <!-- 订单详情  -->
    <order-detail ref="orderDetail"></order-detail>

  </div>
</template>

<script>
import orderDetail from '@/components/commons/orderDetail';
export default {
  props: ["row"],
  components:{
    orderDetail
  },
  data() {
    return {
      
    };
  },

  methods:{
    
  }
};
</script>

<style lang="scss" scoped>
.success {
  display: flex;
  justify-content: center;
  .success-num {
    text-align: center;
    border-bottom: 1px solid #2d8cf0;
  }
  .policy-list-box {
    padding: 13px 15px;
    display: flex;
    flex-direction: column;
    .title {
      text-align: left;
      font-size: 12px;
      color: #3c464f;
      margin-bottom: 5px;
    }
    .list {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      .policy-label {
        color: #515c6f;
        font-size: 12px;
      }
      .policy-number {
        color: #2d8cf0;
        font-size: 12px;
        margin-left: 8px;
        border-bottom: 1px solid #2d8cf0;
      }
    }
  }
}
</style>